import React, { useState } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";

import QRCodeGenerator from "../../views/Profile/QRCode";

function QRCode() {
  const login = useSelector((state) => state.login);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <div className="qr-code-header">
      {/* <div className="qr-code-container">
        <span className="qr-icon" id="QR" onClick={toggle}>
          <i className="fas fa-qrcode"></i>
        </span>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        size="sm"
        className="qr-modal"
      >
        <ModalBody style={{ padding: "20px" }}>
          <div className="qr-cust-name"> {login.data.cust_name} </div>
          <div className="qr-cust-numb">
            {" "}
            {login.data.cust_contact.replace(/.(?=.{4,}$)/g, "x")}{" "}
          </div>
          <div style={{ marginBottom: "20px" }}>
            <QRCodeGenerator {...login.data} />
          </div>
        </ModalBody>
      </Modal> */}
    </div>
  );
}

export default withRouter(QRCode);
